import httpMixin from "@/v2/mixins/http.js";
import {
    ProductAttribute,
    ProductAttributeFactory,
    ProductAttributeMapperParameter,
} from "@/v2/models/product-attributes";
import mapperMixin from "@/v2/mixins/mapper.js";

export default {
    mixins: [httpMixin, mapperMixin],
    computed: {
        productAttributesUrl: {
            get() {
                return window.bo.productAttributesUrl;
            },
        },
        attributeOptionsUrl: {
            get() {
                return window.bo.attributeOptionsUrl;
            },
        },
    },
    methods: {
        _productAttributeOptionMapper(productAttributeOption) {
            return {
                id: productAttributeOption.id,
                attribute_id: productAttributeOption.attribute_id,
                slug: productAttributeOption.slug,
                name: productAttributeOption.name,
                type: productAttributeOption.type,
                order: productAttributeOption.order,
                position: productAttributeOption.position,
                bo_can_delete: true,
                show_action_menu: true,
            };
        },

        _productAttributeMapper(productAttribute) {
            return {
                id: productAttribute.id,
                name: productAttribute.name,
                slug: productAttribute.slug,
                count: productAttribute.count,
                options: productAttribute.options,
            };
        },

        parseProductAttribute(productAttribute) {
            // forward the data to ProductAttributeMapperParameter
            return ProductAttributeFactory.construct(
                this.createMapperParameter(new ProductAttributeMapperParameter()),
                productAttribute
            );
        },

        //
        parseProductAttributes(productAttributes) {
            let parsedProductAttributes = [];

            productAttributes.forEach((productAttributeData) => {
                const productAttribute = this.parseProductAttribute(productAttributeData);
                parsedProductAttributes.push(productAttribute);
            });

            return parsedProductAttributes;
        },

        createProductAttribute(url, payload, success, failure) {
            return this.postData(
                url,
                payload,
                (response) => {
                    success(this.parseProductAttribute(response.data));
                },
                failure
            );
        },

        updateProductAttribute(id, url, payload, success, failure) {
            return this.putData(
                `${url}/${id}`,
                payload,
                (response) => {
                    success(this.parseProductAttribute(response.data));
                },
                failure
            );
        },

        getProductAttribute(id, url, payload, success, failure) {
            return this.getData(
                url + "/" + id,
                payload,
                (response) => {
                    success(this.parseProductAttribute(response.data));
                },
                failure
            );
        },

        getProductAttributes(payload, success, failure) {
            return this.getData(
                this.productAttributesUrl,
                payload,
                (response) => {
                    // console.log(response.data.data);
                    success(this.parseProductAttributes(response.data.data), response.data.meta);
                },
                failure
            );
        },

        getAttributesOptions(payload, success, failure) {
            return this.getData(
                this.attributeOptionsUrl,
                payload,
                (response) => {
                    success(this.parseProductAttributes(response.data.data), response.data.meta);
                },
                failure
            );
        },

        deleteProductAttribute(id, url, payload, success, failure) {
            return this.deleteData(
                `${url}/${id}`,
                payload,
                (response) => {
                    success(response.data);
                },
                failure
            );
        },

        deleteProductAttributes(url, payload, success, failure) {
            return this.postBulkData(
                url,
                null,
                null,
                payload,
                (response) => {
                    success(response.data);
                },
                failure
            );
        },

        createOrUpdateProductAttribute(id = null, url, payload, success, failure) {
            if (id == null) {
                return this.createProductAttribute(url, payload, success, failure);
            } else {
                return this.updateProductAttribute(id, url, payload, success, failure);
            }
        },
    },
};
